import React from "react";
import styled from "styled-components";

export default function EcommerceDescription() {
  return (
    <ul>
      <ListItem>
        <b>Efficient state management using Redux.</b>
      </ListItem>
      <ListItem>
        <b>Smooth animations with Framer Motion</b>
      </ListItem>
      <ListItem>
        <b>Responsive design with TailwindCSS</b>
      </ListItem>
      <ListItem>
        <b>Built with Atomic Design principles.</b>
      </ListItem>
      <ListItem>
        <b>
          Next.js allowing for the creation of dynamic and nested routes with
          ease.
        </b>
      </ListItem>
      <ListItem>
        <b>Users are able to:</b> <br />
        - Browse products dynamically fetched from a API <br /> - Add products
        to the cart. <br /> - Load products with infinite scroll <br /> - Sort
        products by categories <br />- View specific product information &
        more...
      </ListItem>
    </ul>
  );
}

const ListItem = styled.li`
  list-style-type: none;
  margin-bottom: 8px;
`;
